import React, { useEffect, useState } from 'react';
import { Button, Select, List, Typography, message } from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { Machine } from '../../../modules/machines/types';
import { fetchMachines } from '../../../modules/machines/api';
import {
  linkMachineToTemplate,
  unlinkMachineFromTemplate,
} from '../../../modules/auditTemplates/api';
import { toast } from 'sonner';

interface Props {
  orgId: string;
  templateId: string;
  linkedMachineIds?: string[];
  isReadOnly?: boolean;
}

const LinkedMachines: React.FC<Props> = ({
  orgId,
  templateId,
  linkedMachineIds = [],
  isReadOnly,
}) => {
  const [machines, setMachines] = useState<Machine[]>([]);
  const [selectedMachineId, setSelectedMachineId] = useState<string | undefined>(undefined);
  const [loading, setLoading] = useState(false);
  const [linking, setLinking] = useState(false);

  useEffect(() => {
    const loadMachines = async () => {
      setLoading(true);
      try {
        const data = await fetchMachines(orgId);
        setMachines(data);
      } catch (error) {
        console.error('Failed to load machines', error);
        message.error('Kunne ikke hente maskiner');
      } finally {
        setLoading(false);
      }
    };

    if (orgId) {
      loadMachines();
    }
  }, [orgId]);

  const handleLink = async () => {
    if (!selectedMachineId) return;
    setLinking(true);
    try {
      const res = await linkMachineToTemplate(orgId, templateId, selectedMachineId);
      console.log('res', res);

      toast.success('Maskine tilknyttet');
      setSelectedMachineId(undefined);
      // Ideally we should update the parent state or re-fetch, but for now we rely on props update if parent re-fetches
      // Or we can optimistically update if we had a callback
    } catch (error) {
      console.error('Failed to link machine', error);
      toast.error('Kunne ikke tilknytte maskine');
    } finally {
      setLinking(false);
    }
  };

  const handleUnlink = async (machineId: string) => {
    try {
      await unlinkMachineFromTemplate(orgId, templateId, machineId);
      message.success('Maskine fjernet');
    } catch (error) {
      console.error('Failed to unlink machine', error);
      message.error('Kunne ikke fjerne maskine');
    }
  };

  const linkedMachines = machines.filter((m) => linkedMachineIds.includes(m.id));
  const availableMachines = machines.filter((m) => !linkedMachineIds.includes(m.id));

  console.log('machines', machines);
  console.log('linkedMachineIds', linkedMachineIds);

  console.log('linkedMachines', linkedMachines);
  console.log('availableMachines', availableMachines);
  return (
    <div style={{ marginTop: 24 }}>
      <Typography.Title level={5}>Tilknyttede Maskiner</Typography.Title>

      {!isReadOnly && (
        <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
          <Select
            style={{ flex: 1 }}
            placeholder="Vælg maskine"
            value={selectedMachineId}
            onChange={setSelectedMachineId}
            loading={loading}
            showSearch
            optionFilterProp="children"
          >
            {availableMachines.map((m) => (
              <Select.Option key={m.id} value={m.id}>
                {m.title || m.id}
              </Select.Option>
            ))}
          </Select>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={handleLink}
            disabled={!selectedMachineId || linking}
            loading={linking}
          >
            Tilføj
          </Button>
        </div>
      )}

      <List
        bordered
        dataSource={linkedMachines}
        renderItem={(item) => (
          <List.Item
            actions={
              !isReadOnly
                ? [
                    <Button
                      type="text"
                      danger
                      icon={<DeleteOutlined />}
                      onClick={() => handleUnlink(item.id)}
                    />,
                  ]
                : []
            }
          >
            {item.title || item.id}
          </List.Item>
        )}
        locale={{ emptyText: 'Ingen maskiner tilknyttet' }}
      />
    </div>
  );
};

export default LinkedMachines;
